import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Award, Flame, Lock } from "lucide-react";
import { api, tradeAuth } from "@/lib/api";

export const PlayerRewards = () => {
  const auth = tradeAuth();
  const [s, setS] = useState(null);
  useEffect(() => {
    if (!auth) return;
    api.get("/player/stats", { params: { session_id: auth.session_id, account_id: auth.account_id } }).then((r) => setS(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.account_id]);
  if (!auth || !s) return null;
  const meter = Math.min(10, s.current_streak);

  return (
    <section className="casino-frame rounded-2xl p-5 sm:p-6" data-testid="player-rewards">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-2"><Flame className="h-5 w-5 text-[#FF6B35]" /><h3 className="font-casino text-xl text-gold-grad">Win streak</h3></div>
        <div className="font-mono-naevo text-xs text-white/60">Best {s.best_streak} · {s.rounds} rounds</div>
      </div>
      <div className="mt-4 flex items-end gap-4">
        <div className="font-casino text-5xl text-gold-grad" data-testid="streak-current">{s.current_streak}</div>
        <div className="pb-1">
          <div className="text-[10px] uppercase tracking-[0.3em] text-gold/70">Streak multiplier</div>
          <div className="font-mono-naevo text-2xl text-white" data-testid="streak-multiplier">×{s.streak_multiplier.toFixed(1)}</div>
        </div>
      </div>
      <div className="mt-3 flex gap-1.5" data-testid="streak-meter">
        {Array.from({ length: 10 }, (_, i) => (
          <motion.div key={i} initial={{ scaleY: 0.4 }} animate={{ scaleY: 1 }} transition={{ delay: i * 0.04 }}
            className={`h-3 flex-1 rounded-full ${i < meter ? (i >= 4 ? "bg-[#C8102E] shadow-[0_0_10px_rgba(200,16,46,0.8)]" : "bg-gold shadow-[0_0_10px_rgba(232,181,74,0.7)]") : "bg-white/10"}`} />
        ))}
      </div>
      <div className="mt-1 flex justify-between text-[10px] font-mono-naevo text-white/40"><span>0</span><span>3 Hat-trick</span><span>5 Hot</span><span>10 Legend</span></div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-2 mt-5">
        {s.badges.map((b) => (
          <div key={b.id} title={b.desc} data-testid={`badge-${b.id}`}
            className={`rounded-xl border p-3 text-center ${b.earned ? "border-gold/60 bg-gold/10" : "border-white/10 bg-white/[0.02] opacity-50"}`}>
            {b.earned ? <Award className="h-5 w-5 mx-auto text-gold" /> : <Lock className="h-5 w-5 mx-auto text-white/40" />}
            <div className="text-[11px] mt-1.5 text-white/85">{b.name}</div>
            <div className="text-[9px] text-white/40 mt-0.5 leading-tight">{b.desc}</div>
          </div>
        ))}
      </div>
    </section>
  );
};
